import React, { useState } from "react";
import { Box, Stack, Typography, useTheme, IconButton } from "@mui/material";
import { alpha } from "@mui/material/styles";
import PhoneIphoneRounded from "@mui/icons-material/PhoneIphoneRounded";
import Button from "../../Button";
import { usePWA } from "../../../contexts/PWAContext";
import CloseIcon from "@mui/icons-material/Close";

const InstallAppBanner = () => {
    const theme = useTheme();
    const { installPWA, isStandalone } = usePWA();
    const [visible, setVisible] = useState(true);

    if (isStandalone() || !visible) return null;

    return (
        <Stack
            className="force-dynamic-translation"
            spacing={1}
            paddingY={1.25}
            paddingX={2}
            width="100%"
            borderRadius="16px"
            boxShadow="0px 2px 8px rgba(0, 0, 0, 0.08)"
            position="relative"
            sx={{
                boxSizing: "border-box",
                bgcolor: alpha(theme.palette.primary.main, 0.06),
            }}
        >
            {/* Row 1: Icon + Heading + Close */}
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
            >
                <Stack direction="row" spacing={1} alignItems="center">
                    <Box
                        sx={{
                            width: 32,
                            height: 32,
                            borderRadius: "8px",
                            bgcolor: alpha(theme.palette.primary.main, 0.12),
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flex: "0 0 auto",
                            color: theme.palette.primary.main,
                        }}
                    >
                        <PhoneIphoneRounded sx={{ fontSize: 18 }} />
                    </Box>
                    <Typography
                        fontWeight={700}
                        fontSize={{ xs: 14, sm: 15 }}
                        lineHeight={1.2}
                        color="text.primary"
                    >
                        Install App
                    </Typography>
                </Stack>
                <IconButton
                    aria-label="Close"
                    onClick={() => setVisible(false)}
                    size="small"
                    sx={{
                        color: "text.secondary",
                        bgcolor: "rgba(0,0,0,0.06)",
                        "&:hover": { bgcolor: "rgba(0,0,0,0.1)" },
                    }}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </Stack>

            {/* Row 2: Copy */}
            <Typography fontSize={13} color="text.secondary">
                Get full functionality with one tap: faster access,
                offline-ready, instant notifications, reminders, confirmations &
                rescheduling.
            </Typography>

            {/* Row 3: Button aligned right */}
            <Stack direction="row" justifyContent="flex-end">
                <Button variant="small" color="primary" onClick={installPWA}>
                    Install
                </Button>
            </Stack>
        </Stack>
    );
};

export default InstallAppBanner;
